import React, { useEffect, useState } from 'react';

import { Segmented } from 'antd';

import { forceReloadPackagePlaylist } from '@hooks/API/Packages/UsePackagePlaylist';
import { forceReloadPackage } from '@hooks/API/Packages/UsePackages';

//import PlayListPreviewDrawer from '@components/MediaDrawer/PlayListPreviewDrawer';
import AddBookForm from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/AddBookForm';

import MiniLoading from '@components/Gui/MiniLoading';
import { NwLinkButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import PlayListInfoForm from '@components/MediaDrawer/PlayListInfoForm';
import { usePlaylistEditor, usePlaylistEditorDispatch } from '@components/PlaylistEditor/PlaylistEditorContext';
import useSaveBook from '@components/PlaylistEditor/useSaveBook';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const PlaylistHeader = () => {
    const { bookToEdit, bookToEditData, selectedModel, onClose, packageID, singlePage } = usePlaylistEditor();

    const playlistID = bookToEdit;

    const dispatch = usePlaylistEditorDispatch();

    const { saveBook, isSaving } = useSaveBook();

    const [renamingBook, setRenamingBook] = useState(false);
    const [touchForm, setTouchForm] = useState(false);
    //const [bookPreview, setBookPreview] = useState(false);

    const [playlistInfo, setPlaylistInfo] = useState({
        Name: '',
        Description: '',
        IsPublished: false,
        PrivacyLevelName: 'Public',
    });

    useEffect(() => {
        if (bookToEditData) {
            setPlaylistInfo({
                Name: bookToEditData.Name || '',
                Description: bookToEditData.Description || '',
                IsPublished: bookToEditData.IsPublished || false,
                PrivacyLevelName: bookToEditData.PrivacyLevelName || 'Public',
            });
        }
    }, [bookToEditData]);

    const handleSaveBook = async () => {
        const saved = await saveBook();
        if (saved) {
            onClose();
        }
    };

    // const handleClearPlaylist = () => {
    //     dispatch({ type: 'ClearPlaylist' });
    // };

    const handleRenameBook = () => {
        setRenamingBook(true);
    };

    if (!bookToEditData) {
        return <MiniLoading />;
    }

    const handleSinglePageChange = (value) => {
        dispatch({ type: 'ToggleSinglePage', value });
    };

    return (
        <>
            {/* <div>
                <Button onClick={handleClearPlaylist}>Clear Playlist</Button>
            </div> */}
            <div className="playlist-header-title">
                <h2>{playlistInfo.Name}</h2>
                <NwLinkButton
                    primary
                    onClick={handleRenameBook}
                    label="Rename Book"
                    icon={byPrefixAndName.fasl['pen']}
                />
            </div>
            <div className="playlist-header-buttons">
                {/* <NwLinkButton
                    primary
                    onClick={() => setBookPreview(true)}
                    label="Preview Book"
                    icon={byPrefixAndName.fasl['eye']}
                /> */}
                <Segmented
                    size="small"
                    options={[
                        { label: 'Double Page', value: false },
                        { label: 'Single Page', value: true },
                    ]}
                    value={singlePage}
                    onChange={handleSinglePageChange}
                />
                <NwSaveButton primary onClick={handleSaveBook} loading={isSaving} label="Save Book" />
            </div>
            {renamingBook && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Edit book"
                    onClose={() => {
                        setRenamingBook(false);
                    }}
                    // padding={0}
                >
                    <PlayListInfoForm
                        playlist={{ ...bookToEditData, ...playlistInfo }}
                        packageID={packageID}
                        onUpdatePlaylists={(updatedPlaylist) => {
                            setPlaylistInfo({
                                Name: updatedPlaylist.Name || '',
                                Description: updatedPlaylist.Description || '',
                                IsPublished: updatedPlaylist.IsPublished || false,
                                PrivacyLevelName: updatedPlaylist.PrivacyLevel || 'Public',
                            });
                            if (packageID) {
                                forceReloadPackagePlaylist(playlistID);
                                forceReloadPackage(packageID);
                            }
                        }}
                        onTouchForm={setTouchForm}
                        onClose={() => setRenamingBook(false)}
                    />
                    {/* <div style={{ padding: '1.6rem' }}>
                        <AddBookForm
                            contactID={selectedModel}
                            onClose={() => {
                                setRenamingBook(false);
                            }}
                            afterCreate={() => {}}
                            onTouchForm={setTouchForm}
                            selectedBook={bookToEditData}
                            onSelectBook={(res) => {
                                setBookName(res.Name);
                            }}
                        />
                    </div> */}
                </NwDrawer>
            )}
            {/* {bookPreview && (
                <PlayListPreviewDrawer
                    playlist={playlistID}
                    contactID={selectedModel}
                    onClose={() => {
                        setBookPreview(false);
                    }}
                />
            )} */}
        </>
    );
};

export default PlaylistHeader;
